export default {
  404: '404',
  register: 'Registro',
  login: 'Acceso',
  grand: 'Magnífico',
  major: 'Importante',
  minor: 'Menor',
  mini: 'Mini',
  crashGameTitle: 'Chocar',
  betAmount: 'Monto de la apuesta',
  profit: 'Ganancia',
  payout: 'Pago objetivo',
  chance: 'Oportunidad de ganar',
  betBtn: 'Apuesta',
  autoCashout: 'Retiro automático',
  btnHalf: '½',
  btnDouble: '2×',
  btnMax: 'máx.',
  wagered: 'Apostado',
  lost: 'Perdido',
  won: 'Ganado',
  gameHotkeys: 'Teclas de acceso rápido',
  gameInfo: 'Información del juego',
  gameLiveStats: 'Estadísticas en vivo',
  gameLoses: 'Pérdidas',
  gameResult: 'Resultado',
  streak: 'Racha',
  detailsText: 'Detalles',
  highestWin: 'Mayor victoria',
  highestLost: 'Mayor perdida',
  highestBet: 'Apuesta más alta',
  maxStreak: 'Racha máxima',
  maxProfit: 'Beneficio máximo: ',
  bal: 'Bal: ',
  controls: 'Controles',
  leaderBoard: 'Tabla de líderes',
  yourBet: 'Tu apuesta',
  messagesNoBetHistory: 'Tu historial de apuestas está vacío.',
  messagesCopyNotSupported: 'Su navegador no admite la copia automática al portapapeles.',
  messagesCopied: 'Dirección copiada.',
  deposit: 'Depósito',
  withdraw: 'Retirar',
  depositHistory: 'Historial de depósitos',
  withdrawalHistory: 'Historial de retiros',
  statReset: 'Restablecer estadísticas',
  rollOver: 'Dese la vuelta',
  inputFieldBtnHalf: '½',
  inputFieldBtnDouble: '2×',
  inputFieldBtnMax: 'máx.',
  buttonTextPlaceBet: 'Realizar apuesta',
  buttonTextCancelBet: 'Cancelar apuesta',
  maxBetText: 'Apuesta máxima',
  buttonTextEscapeBet: 'Retiro',
  buttonTextStartAutoBet: 'Iniciar apuesta automática',
  buttonTextCancelAutoBet: 'Cancelar apuesta automática',
  buttonTextLoading: 'Cargando',
  tabsMyBets: 'Mis apuestas',
  tabsDeposit: 'Depósito',
  tabsCashout: 'Retiros',
  tabsAllbets: 'Todas las apuestas',
  tabsTopbets: 'Apuestas principales',
  tabsBonus: 'Prima',
  tabsjackpot: 'Bote',
  tabsBetHistory: 'Historial de apuestas',
  timerTextCurrentPayout: 'Pago actual',
  timerTextStarting: 'Comenzando en',
  timerTextSec: 's',
  timerTextFlewAway: 'Se estrelló',
  timerTextWait: 'Espere por favor..',
  timerTextPreparingRound: 'Ronda de preparación',
  timerTextLoadingRound: 'Ronda de carga',
  comingSoon: 'Muy pronto',
  labelsProfitOnWin: 'Ganancia al ganar',
  inputsNoOfBets: 'Número de apuestas',
  inputsAuto: 'Auto',
  inputsHalf: '1/2',
  inputsDouble: '2×',
  inputsStart: 'Comenzar',
  inputsCancel: 'Cancelar',
  buttonsMin: 'mín.',
  buttonsMax: 'máx.',
  prediction: 'Predicción',
  luckyNumber: 'Número de la suerte',
  multiplier: 'Multiplicador',
  chanceToWin: 'Oportunidad de ganar',
  bets: 'Apuestas',
  depositBtn: 'Depósito',
  rollUnder: 'Rodar hacia abajo',
  symbolsX: 'incógnita',
  symbolsPercent: '%',
  navBarTitle: 'Historia',
  navBarMyBets: 'Mis apuestas',
  navBarAllBets: 'Todas las apuestas',
  navBarHighRollers: 'Grandes apostadores',
  navBarRoundHistory: 'Historia de la ronda',
  navBarTotal: 'Apuestas totales',
  totalProfit: 'beneficio total',
  topHeaderBetId: 'ID de apuesta',
  topHeaderUser: 'Usuario',
  topHeaderPayout: 'Pago',
  topHeaderAmount: 'Cantidad',
  topHeaderTime: 'Tiempo',
  topHeaderProfit: 'Ganancia',
  topHeaderRoundCrashed: 'Se estrelló',
  topHeaderRoundEscape: '@',
  topHeaderRoundRoundHash: 'Picadillo',
  topHeaderRoundBet: 'Apuesta',
  topHeaderRoundProfit: 'Ganancia',
  topHeaderRoundSignature: 'Firma',
  roundHistoryTitle: 'INFORMACIÓN DEL JUEGO',
  roundHistoryDescGame: 'Juego #',
  roundHistoryDescCrashAt: 'Se estrelló en:',
  roundHistoryDescDate: 'Fecha :',
  roundHistoryDescBetHeader: 'Apuesta#',
  roundHistoryTableTitlePlayer: 'JUGADOR',
  roundHistoryTableTitleBet: 'APUESTA',
  roundHistoryTableTitleCashedOut: 'COBRADO',
  roundHistoryTableTitleProfit: 'GANANCIA',
  roundHistoryTableTitleBetId: 'ID DE APUESTA',
  roundHistoryMessagesNoBetHistory: 'Tu historial de apuestas está vacío.',
  placedBetsTabPlaced: 'Apuesta realizada',
  placedBetsTabPrev: 'Apuesta anterior',
  placedBetsTitleUser: 'Usuario',
  placedBetsTitleEscape: 'Multi.x',
  placedBetsTitleBet: 'Apuesta',
  placedBetsTitleProfit: 'Ganancia',
  placedBetsTitleCashout: 'Retiro',
  placedBetsNoPlacedBet: 'No se realizan apuestas.',
  provablyFairContentCheckBtn: 'Verificar feria demostrable',
  provablyFairContentTitle: 'Demostrablemente justo',
  provablyFairContentDesc: 'Se puede demostrar que el resultado de la ventaja de cuatro lados es justo. ',
  provablyFairContentInputFieldsCrashRateTitle: 'Tasa de accidentes',
  provablyFairContentInputFieldsCrashRatePlaceHolder: 'Tasa de accidentes sin x',
  provablyFairContentInputFieldsRoundHashTitle: 'Hash redondo',
  provablyFairContentInputFieldsRoundHashPlaceHolder: 'p.ej. ',
  provablyFairContentInputFieldsSubmitBtn: 'Generar firma',
  provablyFairContentSignature: 'Firma redonda',
  provablyFairContentErrorsCrashRate: 'por favor ingrese el número en el campo de tasa de accidentes',
  gameVerifyGameHeading: 'Verificar juego',
  notFoundDataMessage: 'No se encontraron datos',
  resetPasswordTitle: 'Restablecer contraseña',
  resetPasswordNewPasswordTitle: 'Nueva contraseña',
  resetPasswordNewPasswordErrorsRequired: '*Se requiere contraseña.',
  resetPasswordNewPasswordErrorsMinLength: 'Se permiten un mínimo de 8 caracteres.',
  resetPasswordNewPasswordErrorsMaxLength: 'Máximo 16 caracteres permitidos.',
  resetPasswordNewPasswordErrorsPattern: '*La contraseña debe tener de 8 a 16 caracteres alfanuméricos y especiales. ',
  resetPasswordConfirmPasswordTitle: 'confirmar Contraseña',
  resetPasswordConfirmPasswordErrorsNotMatched: 'Las contraseñas no coinciden.',
  resetPasswordResetBtn: 'Reiniciar',
  resetAllBtn: 'Restablecer todo',
  passwordResetSuccess: 'La contraseña se cambió correctamente.',
  resetPasswordWentWrong: '¡Algo salió mal!',
  levelGrand: 'MAGNÍFICO',
  levelMajor: 'IMPORTANTE',
  levelMinor: 'MENOR',
  levelMini: 'MINI',
  bannerContentWinDaily: 'Gana $1000 diarios ',
  bannerContentContest: 'Concursos ahora ',
  bannerContentjoin: '¡Únete a nuestro concurso de apuestas diario y conviértete en el héroe!  ',
  bannerContentPlayNow: 'Jugar ahora',
  bannerContentTitle: 'Gana el premio mayor',
  bannerContentContent: 'Juega más y más juegos y ten la oportunidad de ganar el premio mayor. ',
  bannerContentGameName: 'JUEGO DE ACCIDENTE',
  bannerContentGameDesc: 'Juega más y más juegos y ten la oportunidad de ganar. ',
  partners: 'Fogonadura',
  gamesGoldenDragon: 'Dragón Dorado',
  gamesCrashGame: 'Juego de choque',
  subCrashGameTitle: 'CrashJuego',
  gamesDice: 'Dados',
  gamesHilo: 'hilo',
  allBetsTitle: 'Todas las apuestas',
  allBetsBetId: 'ID de apuesta',
  allBetsUser: 'Usuario',
  allBetsPayout: 'Pago',
  allBetsAmount: 'Cantidad',
  allBetsTime: 'Tiempo',
  allBetsProfit: 'Ganancia',
  LoginwithOtp: 'Iniciar sesión con Otp',
  EnterLoginOtp: 'Ingresar Iniciar Sesión Otp',
  submit: 'Entregar',
  footerAboutUs: 'Sobre nosotros',
  copyRights: 'Reservados todos los derechos',
  gameFooterLicenseText: '  Moolah hub tiene licencia de BCLB (Junta de Licencias de Control de Apuestas de Kenia) según la Ley de Apuestas, Loterías y Juegos, Cap 131, Leyes de Kenia bajo el número de licencia: 0000610 y PG 0000348.',
  footerFaq: 'Preguntas frecuentes',
  footerSitePolicy: 'Política del sitio',
  footerResponsibleGambling: 'Juego responsable',
  footerTerms: 'Términos y condiciones',
  footerCopywrite: '2022 LÍNEA CRIPTO. ',
  signinTitle: 'Acceso',
  signinUsername: 'Nombre de usuario/correo electrónico',
  signinPassword: 'Contraseña',
  signinLoginBtn: 'Acceso',
  signinSignup: '¡Inscribirse!',
  signinForgetPassword: '¿Has olvidado tu contraseña?',
  signinDontHaveAccount: '¿No tienes una cuenta? ',
  signinCreateAccount: 'Crear una cuenta',
  signinLoginDescription: 'En ocasiones, Moola Hub Gaming puede enviarle ofertas gratuitas y promociones especiales por correo electrónico o SMS. ',
  signinErrorsUserNameRequired: '*Por favor ingrese nombre de usuario/correo electrónico.',
  signinErrorsUserNameMinLength: 'Se permiten un mínimo de 4 caracteres.',
  signinErrorsUserNameMaxLength: 'Máximo 20 caracteres permitidos.',
  signinErrorsUserNamePattern: 'Por favor ingrese un nombre de usuario válido, solo se permiten letras y números.',
  signinErrorsPasswordRequired: '*Se requiere contraseña.',
  signinErrorsPasswordMinLength: 'Se permiten un mínimo de 8 caracteres.',
  signinErrorsPasswordMaxLength: 'Máximo 16 caracteres permitidos.',
  signinErrorsPasswordPattern: '*La contraseña debe tener de 8 a 16 caracteres alfanuméricos y especiales. ',
  signinSuccessfullyLoggedIn: 'Inicie sesión exitosamente.',
  signinResetMailSent: 'Se envió el correo electrónico para restablecer la contraseña.',
  signinTryAgain: '¡Algo salió mal! Inténtalo de nuevo.',
  signinResetPasswordUsernameErr: 'Ingrese el nombre de usuario/correo electrónico para restablecer la contraseña.',
  signinResetMailSentSuccessContent: 'Le enviamos un enlace para restablecer la contraseña a su correo electrónico. ',
  signupTitle: 'Registro',
  signupUsername: 'Nombre de usuario',
  signupEmail: 'Correo electrónico',
  signupTermsConditions: 'Términos y condiciones',
  signupWalletConnect: 'Iniciar sesión con billetera ',
  signupPassword: 'Contraseña',
  signupEighteenPlus: 'Soy mayor de 18 años y acepto los Términos de servicio',
  signupRegisterBtn: 'Inscribirse',
  signupCreateNewAccount: 'Crear nueva cuenta',
  signupFullName: 'Nombre completo',
  signupReferralCode: 'Código de referencia',
  signupConfirmPassword: 'confirmar Contraseña',
  signupUseSocialAccount: 'O use una cuenta social',
  signupFacebook: ' Facebook',
  signupGoogle: ' Google',
  signupHaveAccount: '¿Tienes una cuenta? ',
  signupLoginBtn: 'Acceso',
  signupErrorsUserNameRequired: '*Por favor ingrese el nombre de usuario.',
  signupErrorsUserNameMinLength: 'Se permiten un mínimo de 4 caracteres.',
  signupErrorsUserNameMaxLength: 'Máximo 20 caracteres permitidos.',
  signupErrorsUserNamePattern: 'Ingrese un nombre de usuario válido, solo se permiten letras y números.',
  signupErrorsFullNameRequired: '*Por favor ingrese el nombre completo.',
  signupErrorsFullNamePattern: 'Por favor ingrese un nombre completo válido, solo se permiten letras y números.',
  signupErrorsEmailRequired: '*Por favor ingrese el correo electrónico.',
  signupErrorsPhoneRequired: '*Por favor ingresa tu número de teléfono.',
  signupErrorsEmailMinLength: 'Se permiten un mínimo de 4 caracteres.',
  signupErrorsEmailMaxLength: 'Máximo 20 caracteres permitidos.',
  signupErrorsEmailPattern: 'Por favor ingrese un correo electrónico válido.',
  signupErrorsPasswordRequired: '*Se requiere contraseña.',
  signupErrorsPasswordMinLength: 'Se permiten un mínimo de 8 caracteres.',
  signupErrorsPasswordMaxLength: 'Máximo 16 caracteres permitidos.',
  signupErrorsPasswordPattern: '*La contraseña debe tener de 8 a 16 caracteres alfanuméricos (mayúsculas y minúsculas) y especiales. ',
  signupErrorsConfirmPasswordMatch: 'La contraseña debe coincidir.',
  signupPlaceholderUserName: 'Mín. ',
  signupPlaceholderEmail: 'p.ej. ',
  signupPlaceholderPassword: 'Mín. ',
  signupSomethingWentWrong: '¡Algo salió mal!',
  signupSignupGoogle: 'Regístrese exitosamente en Google.',
  signupRegistered: 'Registrado exitosamente.',
  signupConfirmAge: 'Por favor confirma que tienes 18 años.',
  signupSignupFacebook: 'Regístrese exitosamente en Facebook.',
  signupCookiesConsent: 'Permita que las cookies de terceros desde la configuración de su navegador utilicen el inicio de sesión social.',
  signupRegisterEmailPopupContent: 'Le enviamos un correo electrónico de verificación. ',
  accountMenuDeposit: 'Depósito',
  accountMenuCashout: 'Retiro',
  accountMenujackpotWinners: 'Ganadores del premio mayor',
  accountMenuTransactions: 'Actas',
  accountMenuPromotions: 'Promociones',
  accountMenuProfile: 'Perfil',
  accountMenuLogout: 'Cerrar sesión',
  accountMenuSound: 'Sonido',
  accountMenuMusic: 'Música',
  accountMenuWithdraw: 'Retirar',
  pageNotFound: '¡No podemos encontrar la página que estás buscando!',
  error: 'Error',
  somethingWentWrong: '¡Algo salió mal!',
  verifyEmailThankYou: '¡Gracias!',
  verifyEmailEmailIsVerified: 'Su correo electrónico está verificado.',
  verifyEmailGoToLogin: 'Ir a la página de inicio de sesión',
  verifyEmailWentWrong: '¡Algo salió mal!',
  verifyEmailTokenExpired: 'Correo electrónico ya verificado o enlace caducado',
  verifyEmailGoToHome: 'Ir a la página de inicio',
  verifyEmailSuccessMsg: 'Correo electrónico verificado exitosamente.',
  gameCardTitle: 'Moola Hub Gaming Sitio de apuestas criptográficas demostrablemente justo',
  bonusSectionTitle: 'Moola Hub JUEGOS',
  bonusSectionSpanText: 'presenta los más generosos y variados',
  bonusSectionBonuses: 'Bonificaciones',
  bonusSectionSubtitleText: 'Juega con placer y obtén recompensas adicionales durante el juego. ',
  bonusSectionHeadingText: 'Bonos de Moola Hub Gaming',
  bonusSectionDesc: 'Como el mejor casino de Bitcoin, Moola Hub Gaming tiene un elaborado sistema de generosos bonos. ',
  JoiningBonusTitle: 'Bonificación por unirse',
  JoiningBonusButton: 'Reclamar ahora',
  JoiningBonusDesc: 'Estos bonos animan a los jugadores de casinos en línea a apostar utilizando Bitcoin u otras criptomonedas. ',
  depositBonusTitle: 'Bono de depósito',
  depositBonusButton: 'Depósito',
  depositBonusDesc: 'Estos bonos animan a los jugadores de casinos en línea a apostar utilizando Bitcoin u otras criptomonedas. ',
  refferBonusTitle: 'Bonificación por recomendación',
  refferBonusButton: 'Depósito',
  refferBonusDesc: 'Estos bonos animan a los jugadores de casinos en línea a apostar utilizando Bitcoin u otras criptomonedas. ',
  aboutSectionTitle: '¿Qué es Moola Hub Gaming?',
  aboutSectionSpanText1: ' Moola Hub Gaming es un innovador sitio de casino Bitcoin, creado teniendo en mente nuevos conceptos de juegos de azar en línea. ',
  aboutSectionSpanText2: 'El casino en línea te permite jugar tus juegos favoritos de forma gratuita o con criptomonedas. ',
  aboutSectionSpanText3: ' En este mundo virtual de apuestas con Bitcoin, puedes disfrutar de muchas oportunidades: jugar tus juegos de casino favoritos, obtener bonos, participar en concursos y promociones.',
  verifiedSectionTitle: 'Software verificado y con licencia',
  verifiedSectionSpanText1: 'No copiamos ni adoptamos software de otros sitios web. ',
  faqSectionTitle: 'Preguntas frecuentes de los jugadores',
  faqSectionForgetPasswordTitle: 'Olvidé mi contraseña.',
  faqSectionForgetPasswordDesc: 'No proporcionó una dirección de correo electrónico de recuperación para su cuenta. ',
  faqSectionMyDepositCreditedTitle: 'Mi depósito no ha sido acreditado.',
  faqSectionMyDepositCreditedDesc: ' Contenido de marcador de posición para este acordeón, cuyo objetivo es demostrar la clase. ',
  SupportedCurrencyTitle: 'Moneda admitida',
  SupportedCurrencySpanText1: 'No copiamos ni adoptamos software de otros sitios web. ',
  CarouselSectionTitle: 'ACCIDENTE DE HODL',
  CarouselSectionSubTitle: ' Juega más juegos y ten la oportunidad de ganar. ',
  WalletSettingTitle: 'Configuración de billetera',
  WalletSettingHideZero: 'Ocultar saldos cero',
  WalletSettingHideZeroInfo: 'Tu saldo cero no aparecerá en tu billetera',
  WalletSettingDisplayFiat: 'Mostrar criptografía en fiat',
  WalletSettingDisplayFiatInfo: 'Todas las apuestas y transacciones se liquidarán en el equivalente criptográfico.',
  WalletSettingNoteForApprox: 'Tenga en cuenta que estas son aproximaciones monetarias.',
  WalletSettingSave: 'Ahorrar',
  WalletSettingNoWalletFound: 'No se encontró ninguna billetera',
  jackpotWinnersNoWinnerAvailable: 'No hay ganadores disponibles',
  jackpotWinnersNew: 'Nuevo',
  jackpotWinnersHeader: 'Ganador del premio mayor',
  jackpotDetailsHeader: 'Detalle del premio mayor',
  jackpotDetailsCampaignPeriod: 'Período de campaña',
  jackpotDetailsFrom: 'De',
  jackpotDetailsTo: 'A',
  jackpotDetailsBettingRule: 'Regla de apuestas',
  jackpotDetailsMinBetAmount: 'Cantidad mínima de apuesta',
  jackpotDetailsMaxBetAmount: 'Cantidad máxima de apuesta',
  jackpotDetailsBetPercentage: 'Porcentaje de apuesta',
  jackpotDetailsWinningRuleHeader: 'Regla ganadora',
  jackpotDetailsWinningRule: 'Realizar apuestas con un monto de apuesta mayor aumentará las posibilidades de ganar.',
  jackpotDetailsProfitRule: 'Si el monto de la apuesta está entre minBetAmount y maxBetAmount, el %betPercentage del monto de la apuesta se agregará al monto del premio mayor.',
  profileTitle: 'Detalles personales',
  profileFName: 'Nombre de pila',
  profileLname: 'Apellido',
  profileUserName: 'Nombre de usuario',
  profileDob: 'Fecha de nacimiento',
  profileEmail: 'Dirección de correo electrónico',
  profilePhone: 'Número de teléfono',
  profileChange: 'Cambiar',
  profileSave: 'Guardar cambio',
  profilePassword: 'Contraseña',
  profileSubmit: 'Entregar',
  phoneNumberPLaceHolderText: 'Introduce tu número de teléfono',
  profileUploadProfile: 'Subir foto',
  profileCurrentPassword: 'Contraseña actual',
  profileNewPassword: 'Nueva contraseña',
  profileConfirmPassword: 'confirmar Contraseña',
  profileScanQRCode: 'Escanear código QR',
  profileEnterSecretCode: 'Ingrese el código secreto',
  profileErrorsFirstNameRequired: 'Se requiere el nombre.',
  profileErrorsFirstNamePattern: 'Por favor ingrese un nombre válido.',
  profileErrorsFirstNameMinLength: 'Se permiten un mínimo de 3 caracteres.',
  profileErrorsFirstNameMaxLength: 'Máximo 20 caracteres permitidos.',
  profileErrorsLastNameRequired: 'Se requiere apellido.',
  profileErrorsLastNamePattern: 'Por favor ingrese un nombre válido.',
  profileErrorsLastNameMinLength: 'Se permiten un mínimo de 3 caracteres.',
  profileErrorsLastNameMaxLength: 'Máximo 20 caracteres permitidos.',
  profileErrorsChangePasswordOldRequired: 'Se requiere contraseña anterior.',
  profileErrorsChangePasswordOldPattern: 'Por favor ingrese una contraseña válida.',
  profileErrorsChangePasswordOldMinLength: 'Se permiten un mínimo de 8 caracteres.',
  profileErrorsChangePasswordOldMaxLength: 'Máximo 16 caracteres permitidos.',
  profileErrorsChangePasswordNewRequired: 'Se requiere una nueva contraseña.',
  profileErrorsChangePasswordNewPattern: 'Por favor ingrese una contraseña válida.',
  profileErrorsChangePasswordNewMinLength: 'Se permiten un mínimo de 8 caracteres.',
  profileErrorsChangePasswordNewMaxLength: 'Máximo 16 caracteres permitidos.',
  profileErrorsChangePasswordNewPasswordNotMatched: 'Las contraseñas no coinciden.',
  profileErrorsChangePasswordNewPasswordMatched: 'La nueva contraseña no puede ser la misma que la contraseña actual.',
  profileErrorsChangePasswordNewRequiredConfirmPass: 'Se requiere confirmar la contraseña.',
  profileErrorsUserNameRequired: 'El nombre de usuario es obligatorio.',
  profileErrorsUserNamePattern: 'Por favor ingrese un nombre válido.',
  profileErrorsUserNameMinLength: 'Se permiten un mínimo de 3 caracteres.',
  profileErrorsUserNameMaxLength: 'Máximo 20 caracteres permitidos.',
  profileErrorsDobRequired: 'Se requiere fecha de nacimiento.',
  profileErrorsEmailRequired: 'Se requiere correo electrónico.',
  profileErrorsEmailPattern: 'Por favor ingrese un correo electrónico válido.',
  profileErrorsEmailMinLength: 'Se permiten un mínimo de 3 caracteres.',
  profileErrorsEmailMaxLength: 'Máximo 20 caracteres permitidos.',
  profileMessagesProfileUpdate: 'Perfil actualizado exitosamente.',
  profileMessagesChangePassword: 'Contraseña actualizada exitosamente.',
  profileProfilePicProfilePicUpload: 'Subir imagen de perfil',
  profileNoNewChanges: '¡No se pudo actualizar el perfil! ',
  profileLoggedInWithSocial: 'Ha iniciado sesión con inicio de sesión social.',
  profileSideNavigatorSound: 'Sonido',
  profileSideNavigatorMusic: 'Música',
  profileSideNavigatorProfile: 'Mi perfil',
  profileSideNavigatorBetHistory: 'Historial de apuestas',
  profileSideNavigatorTransactions: 'Actas',
  profileSideNavigatorDeposit: 'Depósito',
  profileSideNavigatorWithdraw: 'Retirar',
  profileSideNavigatorGameLimits: 'Límites del juego',
  profileSideNavigatorReferral: 'Remisión',
  profileSideNavigatorChangePassword: 'Cambiar la contraseña',
  profileSideNavigatorTermsConditions: 'Términos y condiciones',
  profileSideNavigatorLogOut: 'Finalizar la sesión',
  profileSideNavigatorProvablyFair: 'Demostrablemente justo',
  WalletInfoSectionNotAvailable: 'No disponible',
  WalletInfoSectionRealBalance: 'Saldo real',
  GameLimitsMinimumBet: 'Apuesta mínima',
  GameLimitsMaximumBet: 'Apuesta máxima',
  GameLimitsMaxWinFor1Bet: 'Ganancia máxima para una apuesta',
  ProvablyFairSubTitle: 'Este juego utiliza tecnología Provably Fair para determinar el resultado del juego. ',
  ProvablyFairMaximumBet: 'Apuesta máxima:',
  ProvablyFairMaxWinFor1Bet: 'Ganancia máxima para una apuesta',
  promotionsTitle: 'Promociones',
  promotionsNoLosingData: 'Lo sentimos, promociones de bonificación No Losing disponibles para ',
  promotionsNoDepositData: 'Lo sentimos, promociones de bonos sin depósito disponibles para ',
  promotionsCurrency: ' divisa.',
  promotionsViewBtn: 'Vista',
  promotionsClaimSuccess: 'Has reclamado con éxito',
  promotionsAvailability: 'Disponibilidad: ',
  promotionsAvailabilityTabLosing: 'Bonificación perdedora',
  promotionsAvailabilityTabDeposit: 'Bono de depósito',
  promotionsDepositBonusTableCode: 'Código',
  promotionsDepositBonusTableMinDeposit: 'Mín. ',
  promotionsDepositBonusTablePercentage: 'Porcentaje',
  promotionsDepositBonusTableMaxBonus: 'Bono máximo',
  promotionsDepositBonusTableRolloverMultipler: 'Multiplicador de rollover',
  promotionsDepositBonusTableMaxRolloverPerBet: 'Rollover máximo por apuesta',
  promotionsDepositBonusTableTimeToAchieveRolloverTarget: 'Es hora de alcanzar el objetivo de renovación',
  promotionsBonusCode: 'CÓDIGO DE BONIFICACIÓN: ',
  promotionsLossesClaim: 'Se pueden reclamar pérdidas por (dentro del período de la campaña): ',
  promotionsLossesClaimLosingBonusTablePercentage: 'Porcentaje',
  promotionsLossesClaimLosingBonusTableMinLosingAmount: 'Mín. ',
  promotionsBonusStatus: 'Estado de bonificación: ',
  promotionsBonusAmount: 'Monto del bono: ',
  promotionsRolloverTarget: 'Objetivo de rollover: ',
  promotionsRolloverAchieved: 'Rollover logrado: ',
  promotionsActivatebtn: 'ACTIVAR',
  promotionsClaimBtn: 'AFIRMAR',
  promotionsCancelBtn: 'CANCELAR',
  promotionsBackBtn: 'ATRÁS',
  promotionsBonus: 'Prima',
  promotionsTermAndConditions: ' Términos y condiciones',
  promotionsClaimDepositBonusTitle: 'Pasos para reclamar el bono de depósito',
  promotionsClaimDepositBonusFirst: 'Activar código de bonificación',
  promotionsClaimDepositBonusSecond: 'Monto del depósito a la billetera',
  promotionsClaimDepositBonusThird: 'Lograr el objetivo de reinversión para reclamar el bono',
  promotionsClaimLosingBonusTitle: 'Pasos para reclamar el bono perdedor',
  promotionsClaimLosingBonusFirst: 'Activar código de bonificación',
  promotionsClaimLosingBonusSecond: 'Juega tus juegos favoritos',
  promotionsClaimLosingBonusThird: 'Haga clic en "Reclamar pérdidas" para reclamar pérdidas dentro del período de la campaña.',
  promotionsWentWrong: '¡Algo salió mal!',
  transactionTitle: 'Actas',
  transactionBetId: 'ID de apuesta',
  transactionUser: 'Usuario',
  transactionPayout: 'Pago',
  transactionAmount: 'Cantidad',
  transactionTime: 'Fecha',
  transactionProfit: 'Ganancia',
  transactionCashout: 'Retiro',
  transactionBet: 'Apuesta',
  transactionMultix: 'Multi.x',
  transactionWin: 'Ganar',
  transactionFairness: 'Justicia',
  transactionReferFriend: 'Recomiende a un amigo',
  transactionTotal: 'Apuestas totales',
  transactionWins: 'gana',
  transactionRefresh: 'Refrescar',
  transactionFilterTopMultipliers: 'Principales multiplicadores',
  transactionFilterHugeWins: 'Grandes victorias',
  transactionFilterBiggestWins: 'Mayores victorias',
  transactionFilterMultipliers: 'Multiplicadores',
  transactionRealBalance: 'Saldo Real',
  depositWithdrawTXDate: 'Fecha',
  depositWithdrawTXAmount: 'Cantidad',
  depositWithdrawTXTxId: 'ID de Tx',
  depositWithdrawTXTxType: 'Tipo de transacción',
  depositWithdrawTXStatus: 'Estado',
  depositWithdrawTXNoData: 'No hay datos disponibles.',
  depositTitle: 'Depósito',
  depositSubTitle: 'El usuario no puede depositar ni retirar moneda fiduciaria. ',
  depositCopyNotSupported: 'Su navegador no admite la copia automática al portapapeles.',
  depositCopied: 'Dirección copiada.',
  depositAddressCreated: 'Dirección creada exitosamente.',
  depositGenerateAddress: 'Generar dirección',
  depositWarningText: 'NO deposite mediante transferencia entre cadenas',
  withdrawTitle: 'Retirar',
  withdrawSubTitle: 'El usuario no puede depositar ni retirar moneda fiduciaria. ',
  withdrawNoteDesc: 'Asegúrese de NO ingresar la dirección BEP2, BEP20 (BSC) como billetera de dirección de retiro de LTC',
  withdrawNoteSublist: ' NO realice retiros como transferencia entre cadenas',
  withdrawWithdrawBtn: 'Solicitud de retiro',
  withdrawFees: 'Tarifa de retiro {{fees}} {{token}}',
  withdrawWithdrawPending: 'Su solicitud de retiro está pendiente. ',
  withdrawEnterFields: 'Ingrese el monto del retiro y la dirección de su billetera.',
  withdrawSelectWallet: 'Seleccione la billetera para retirar.',
  withdrawAmountFieldTitle: 'Importe (Mín. 0,03 {{wallet.currency.code}})',
  withdrawAmountFieldPlaceholder: '0',
  withdrawAddressFieldTitle: 'Su {{wallet.currency.code}} DIRECCIÓN',
  withdrawAddressFieldPlaceholder: 'Escribe tu dirección',
  withdrawNoBalance: 'Saldo insuficiente.',
  withdrawMinAmount: 'Por favor ingrese una cantidad mayor o igual a {{min}} .',
  fiatCurrencyInfo: 'El usuario no puede depositar ni retirar moneda fiduciaria. ',
  paginationNextBtn: 'Próximo',
  paginationPrevBtn: 'Anterior',
  wentWrong: 'Algo salió mal.',
  referralTitle: 'Remisión',
  referralSubTitle: 'Recomiende a sus amigos',
  referralEarn: ' Gana 150 INR cada uno',
  referralReferAndEarn: 'Recomiende y gane bonos por cada recomendación',
  referralReferPara: ' Si refiere este código a cualquier usuario y registro de usuario con su código de referencia, obtendrá una bonificación del 100 % en su cuenta.',
  referralReferLink: 'Enlace de referencia',
  referralCopyReferralCode: 'Copiar código de referencia',
  referralTotalRewards: 'Recompensa total',
  TwoWayAuthentication: 'Autenticación bidireccional',
  LoginRequired: '¡Es necesario iniciar sesión!',
  BetPlacedSuccessfully: 'Apuesta realizada con éxito',
  BetAddedInQueueSuccessfully: 'Apuesta agregada en la cola con éxito',
  BetRemovedFromQueueSuccessfully: 'Apuesta eliminada de la cola con éxito',
  BetCancelledSuccessfully: 'Apuesta cancelada con éxito',
  PlayerEscapedSuccessfully: 'El jugador escapó con éxito',
  CopiedSuccessfull: 'Copiado exitosamente',
  NotEnoughBalance: 'Saldo insuficiente',
  AutoBetStarted: 'Apuesta automática iniciada ',
  AutoBetFinished: 'Apuesta automática finalizada ',
  IdCopied: 'ID copiado',
  usersConsent: 'Al acceder a este sitio, confirmo que tengo 18 años y he revisado.',
  termsOfService: 'Términos de servicio',
  email: 'Correo electrónico',
  playNow: 'Jugar ahora',
  orContinueWith: 'O continuar con',
  metamaskExtensionNotAvailable: 'Instale la extensión metaMask y actualice la página.',
  cashier: 'CAJERO',
  account: 'CUENTA',
  hello: 'Hola',
  balance: 'Balance',
  referrals: 'Referencias',
  settings: 'Ajustes',
  withdrawals: 'Retiros',
  demoWallet: 'Cartera de demostración',
  myAccount: 'Mi cuenta',
  wallet: 'Billetera',
  user: 'Usuario',
  USD: 'Dólar estadounidense',
  amountIsRequired: 'Se requiere cantidad',
  minDepositAmount: 'El monto del depósito debe ser mayor que {{min}}.',
  maxDepositAmount: 'El monto del depósito debe ser menor que {{max}}.',
  minWithdrawAmount: 'El monto del retiro debe ser mayor que {{min}}',
  withdrawMustLessThanWallet: 'El monto del retiro debe ser menor que el monto de su billetera',
  accountTypeIsRequired: 'Se requiere el tipo de cuenta.',
  mobileNumberLength: 'El número de móvil debe ser de {{length}} dígitos',
  phoneIsRequired: 'Se requiere teléfono',
  cpfError: 'El CPF debe ser de {{length}} personajes',
  cpfRequiredError: 'Se requiere CPF',
  cnpjError: 'El CNPJ debe ser de {{length}} personajes',
  mainMenu: 'MENÚ PRINCIPAL',
  casino: 'Casino',
  sports: 'Deportes',
  crypto: 'Cripto',
  NFT: 'NFT',
  poker: 'Póker',
  earnRewards: 'GANA RECOMPENSAS',
  rankUp: 'Subir de rango',
  inviteFriends: 'invitar amigos',
  partnerProgram: 'Programa de socios',
  home: 'Hogar',
  sportsbook: 'Apuestas deportivas',
  menu: 'Menú',
  liveBets: 'APUESTAS EN VIVO',
  allBets: 'Todas las apuestas',
  highRollers: 'Grandes apostadores',
  luckyBets: 'Apuestas afortunadas',
  trade: 'Comercio',
  game: 'JUEGO',
  player: 'JUGADOR',
  time: 'TIEMPO',
  wager: 'APOSTAR',
  multiplierBan: 'MULTIPLICADOR',
  payoutText: 'PAGO',
  bannerHeadOne: 'Experimente la verdadera innovación con la más alta',
  bannerHeadTwo: 'programa de recompensas dentro de la industria.',
  registerNow: 'Regístrese ahora',
  liveWins: 'GANANCIAS EN VIVO',
  monthlyStatus: 'METRO',
  weeklyStatus: 'W.',
  dailyStatus: 'D',
  clutchEcosystem: 'Ecosistema Moola Hub',
  allGames: 'Todos los juegos',
  allSports: 'Todos los deportes',
  cryptoFutures: 'futuros criptográficos',
  tradeNow: 'Opere ahora',
  $clutch: '$Moola Centro',
  allTables: 'Todas las tablas',
  nft: 'NFT',
  viewAll: 'Ver todo',
  rewards: 'RECOMPENSAS',
  profile: 'Perfil',
  clutchProfile: 'PERFIL de Moola Hub',
  totalBets: 'Apuestas totales',
  totalWagered: 'Total apostado',
  joinDate: 'Fecha de incorporación',
  displaySocialLinks: 'Mostrar cuentas sociales vinculadas',
  privateProfile: 'Perfil privado',
  rank: 'Rango',
  nextRank: 'Siguiente rango',
  changeUsername: 'Cambiar nombre de usuario',
  newPassword: 'Nueva contraseña',
  changeName: 'Cambiar nombre',
  linkSocialAccount: 'Vincular cuenta social',
  privateProfileTooltip: 'Después de hacer que su perfil sea privado, otros usuarios no verán su nombre de usuario junto con las apuestas, carreras, etc.',
  socialLinksTooltip: 'Contenido no disponible',
  rankTooltip: 'Contenido no disponible',
  balances: 'saldos',
  createReferralBalance: 'Crear saldo de referencia',
  total: 'Total',
  switchBalance: 'Cambiar equilibrio',
  mainAccount: 'Cuenta principal',
  tips: 'Consejos',
  receivedAmount: 'Monto recibido',
  dateOrTime: 'Fecha/Hora',
  view: 'Vista',
  allChains: 'Todas las cadenas',
  creditAmount: 'Monto del crédito',
  setCustomReferralCode: 'Establecer código de referencia personalizado',
  changeEmail: 'Cambiar correo electrónico',
  newEmail: 'Nuevo correo electrónico',
  createPassword: 'Crear contraseña',
  newUsername: 'Nuevo nombre de usuario',
  username: 'Nombre de usuario',
  changePassword: 'Cambiar la contraseña',
  twoFactorAuthentication: 'autenticación de dos factores',
  twoFactorAuthenticationTitle: 'Se recomienda encarecidamente utilizar la autenticación de dos factores porque protege su cuenta tanto con su contraseña como con su teléfono.',
  twoFactorAuthenticationSubTitle: 'Se debe configurar un correo electrónico y una contraseña para activar 2FA. ',
  enable2fa: 'HABILITAR 2FA',
  verifyIdentityByKyc: 'Verifica tu identidad (kyc)',
  oldPassword: 'Contraseña anterior',
  live: 'Vivir',
  soccer: 'Fútbol',
  tennis: 'Tenis',
  fifa: 'FIFA',
  basketball: 'Baloncesto',
  iceHockey: 'hockey sobre hielo',
  volleyball: 'Voleibol',
  tableTennis: 'Tenis de mesa',
  baseball: 'Béisbol',
  rubgy: 'Rugby',
  golf: 'Golf',
  boxing: 'Boxeo',
  myBets: 'Mis apuestas',
  favourites: 'Favoritos',
  americanFootball: 'Fútbol americano',
  buyCrypto: 'Comprar criptomonedas',
  oldEmail: 'Correo electrónico antiguo',
  loggedInSuccess: 'Inicie sesión exitosamente',
  loggedOutSuccess: 'Cerró sesión exitosamente',
  signup: 'El usuario se ha registrado correctamente',
  tokenVerify: 'El token ha sido enviado a su correo electrónico, verifique',
  emailVerify: 'El correo electrónico ha sido verificado.',
  emailChangedSuccess: 'El correo electrónico se ha cambiado correctamente.',
  profileUpdatedSuccess: 'Perfil actualizado',
  otpVerified: 'OTP verificada',
  twoFADeactivated: 'Autenticación 2FA desactivada',
  internalServerError: 'Error Interno del Servidor',
  unAuthorized: 'No autorizado',
  dataNotFound: 'Datos no encontrados',
  setReferralCode: 'Establecer código de referencia...',
  ultimate: 'ÚLTIMO',
  notFound: 'Extraviado',
  originals: 'Originales MH',
  casinoTransactions: 'Transacciones de casino',
  clutchOriginals: 'Originales de Moola Hub',
  sportsbookTransactions: 'Transacciones de apuestas deportivas',
  status: 'Estado',
  success: 'Éxito',
  failed: 'Fallido',
  pending: 'Pendiente',
  date: 'Fecha',
  to: 'A',
  gameName: 'Nombre del juego',
  eventId: 'ID de evento',
  transactionId: 'ID de transacción',
  roundId: 'ID redondo',
  bet: 'Apuesta',
  win: 'Ganar',
  transactionType: 'Tipo de transacción',
  at: 'en',
  downloadAll: 'Descargar todo',
  gameText: 'Juego',
  betId: 'ID de apuesta',
  gameId: 'ID del juego',
  actionType: 'Tipo de acción',
  searchGames: 'Buscar juegos',
  provider: 'Proveedor',
  search: 'Buscar',
  all: 'Todo',
  sortBy: 'Ordenar por',
  popular: 'Popular',
  challengePool: 'Grupo de desafíos',
  loadMore: 'Cargar más',
  showMore: 'Mostrar más',
  bitcoin: 'bitcóin',
  btc: 'btc',
  chat: 'Charlar',
  trades: 'Vientos alisios',
  battles: 'Batallas',
  loginToChat: 'Inicia sesión para chatear',
  rules: 'Normas',
  send: 'Enviar',
  expand: 'Expandir',
  signIn: 'Iniciar sesión',
  cross: 'Cruz',
  collapse: 'Colapsar',
  emailPlaceholder: 'tucorreo electrónico@dominio.com',
  removeFromFavourite: 'Quitar de favoritos',
  addToFavourite: 'Añadir a favoritos',
  verify: 'Verificar',
  change: 'Cambiar',
  accountVerification: 'Verificación de cuenta',
  gamesNotFound: 'Juegos no encontrados',
  recentlyPlayed: 'Jugado recientemente',
  moreFrom: 'Más de',
  demoMode: 'Modo de demostración',
  providersList: 'Lista de proveedores',
  games: 'Juegos',
  providers: 'Proveedores',
  close: 'Cerca',
  joinedOn: 'Se unió a',
  rewarded: 'Recompensado',
  favouriteGame: 'juego favorito',
  saySomething: 'Di algo',
  onlySendToAddress: 'solo enviar {{currencyCode}} a esta dirección',
  yourAddress: 'Tu dirección',
  addressIsRequired: 'Se requiere dirección',
  withdrawRequestSent: 'Solicitud de retiro enviada al administrador. ¡Espere la aprobación!',
  noMatchesFound: 'No se encontraron coincidencias',
  tip: 'CONSEJO',
  sendTip: 'Enviar propina',
  minAmount: 'La cantidad debe ser mayor que {{min}}',
  maxAmount: 'La cantidad debe ser menor que {{max}}',
  doNotShowTip: 'No mostrar propina en el chat',
  demoAvailable: 'Demostración disponible',
  denoNotAvailable: 'Demostración no disponible',
  goFullscreen: 'Ir a pantalla completa',
  endsAt: 'Termina en',
  inProgress: 'En curso',
  eventEnd: 'Fin del evento',
  latestPromotions: 'Últimas promociones',
  archived: 'Archivado',
  noPromotionsFound: 'No se encontraron promociones',
  claim: 'Afirmar',
  add: 'Agregar',
  viewDashboard: 'Ver panel',
  prize: 'Premio',
  timeLeft: 'Tiempo restante',
  viewTransactions: 'Ver transacciones',
  sendAmountInCashier: 'enviar la cantidad de {{currency}} de su elección a la siguiente dirección para recibir el equivalente en Monedas.',
  yourPersonalDepositAddress: 'Tu personal {{currency}} dirección de depósito',
  copyAddress: 'Copiar dirección',
  theValueOfCurrencyMayChange: 'el valor de {{currency}} puede cambiar desde ahora hasta el momento en que recibamos su pago',
  doNotHaveAnyCurrency: 'no tengo ninguno {{currency}}?',
  depositOptions: 'Opciones de depósito',
  withdrawalOptions: 'Opciones de retiro',
  withdrawCurrency: 'Retirar {{currency}}',
  enterAddressToReceiveFunds: '  Por favor ingrese el {{currency}} dirección de billetera en la que desea recibir los fondos. ',
  receivingCurrencyAddress: 'Recepción {{currency}} DIRECCIÓN',
  withdrawalAmount: 'Monto del retiro',
  pasteYourCurrencyAddressHere: 'Pega tu {{currency}} dirección de billetera aquí...',
  requestWithdrawal: 'Solicitar retiro',
  receiveTheSpecifiedAmount: '*Recibirás lo especificado {{currency}} monto a su dirección de retiro',
  valueMayVary: '*El valor restado de tu saldo puede variar desde ahora hasta el momento en que procesemos tu retiro.',
  coupons: 'Cupones',
  depositAddress: 'Depósito {{currency}} DIRECCIÓN',
  updateEmail: 'Actualizar correo electrónico',
  update: 'Actualizar',
  loginHistory: 'Historial de inicio de sesión',
  showLoginHistory: 'Mostrar historial de inicio de sesión',
  currencyErr: 'Se requiere identificación de moneda',
  wagerErr: 'Se requiere el monto de la apuesta',
  minWagerErr: 'El monto mínimo de la apuesta es 1',
  mulValErr: 'Valor multiplicador entre 1 - 1000',
  closeBetErr: 'Ingrese el monto válido de la apuesta cerrada',
  profitErr: 'Ingrese un monto de obtención de ganancias válido',
  multiplierErr: 'Se requiere cantidad multiplicadora',
  euro: 'Euro',
  manual: 'Manual',
  auto: 'Auto',
  pnLFee: 'Tarifa PNL',
  flatFee: 'Tarifa fija',
  takeProfitLabel: 'TOMAR BENEFICIOS A PRECIO',
  closeBetLabel: 'CERRAR APUESTA AL PRECIO',
  priceUpLabel: '¿EL PRECIO SUBIRÁ O BAJARÁ?',
  up: 'ARRIBA',
  down: 'ABAJO',
  payoutMul: 'MULTIPLICADOR DE PAGO',
  bustPrice: 'Precio de caída',
  safe: 'Seguro',
  wild: 'Salvaje',
  placeBet: 'Realizar apuesta',
  roundEnd: 'LA REDONDA TERMINA EN',
  timerInfo: 'Todas las apuestas de montaña rusa se cerrarán y el precio se restablecerá a $1000 cada día a las 00:00 UTC.',
  month: 'mes',
  PNL: 'PNL',
  ROI: 'retorno de la inversión',
  roi: 'rey',
  funding: 'Financiamiento/H',
  exitPriceLabel: 'Precio de salida',
  cashedOut: 'Cobrado',
  open: 'Abierto',
  chartPreferences: 'Preferencias de gráficos',
  yAxis: 'Preferencias del eje Y',
  additionalFeatures: 'Funciones adicionales',
  themes: 'Temas',
  locale: 'Lugar',
  changeTimezone: 'Cambiar zona horaria',
  changeLanguage: 'Cambiar idioma',
  tooltip: 'Información sobre herramientas',
  field: 'Campo',
  value: 'Valor',
  dateTime: 'Fecha/Hora',
  simulator: 'simulador',
  random: 'ALEATORIO',
  myMarket: 'Mi_mercado',
  marketCount: 'América/Chicago',
  mountain: 'montaña',
  candle: 'vela',
  winningAmount: 'cantidad ganadora',
  activeBets: 'Apuestas activas',
  closedBets: 'Apuestas cerradas',
  publicBets: 'Apuestas públicas',
  leaderboard: 'Tabla de clasificación',
  howToplay: 'Cómo jugar',
  rOICalculator: 'Calculadora de retorno de la inversión',
  priceFormulation: 'Formulación de precios',
  howToplayPriceFormulation: 'Cómo jugarFormulación de precios',
  allInstruments: 'Todos los instrumentos',
  week: 'Semana',
  monthLabel: 'Mes',
  day: 'Día',
  betLabel: 'APUESTA',
  entryPrice: 'PRECIO DE ENTRADA',
  bustPriceLabel: 'Precio de caída',
  multiplierLabel: 'MULTIPLICADOR',
  exitPrice: 'PRECIO DE SALIDA',
  pnl: 'PyG',
  manualType: 'manual',
  pnlType: 'pnl',
  takeProfitAmount: 'tomarProfitAmount',
  profitType: 'ganancia',
  stopLossAmount: 'detenerLossAmount',
  stopLoss: 'detener la pérdida',
  details: 'Ver detalles',
  profitLoss: 'Ganancias y pérdidas',
  noBalance: 'Saldo insuficiente.',
  maxBetAmount: 'Cantidad máxima de apuesta',
  limit: 'límite superado.',
  minBetAmount: 'Cantidad mínima de apuesta',
  rollsLimitMsg: 'El número de rollos debe ser menor o igual a 100.',
  mines: 'minas',
  loginFailed: 'error de inicio de sesion',
  noEntries: 'No hay entradas',
  descriptionIsRequired: 'Se requiere descripción',
  description: 'Descripción',
  report: 'Informe',
  userReportedSuccessfully: 'Usuario reportado exitosamente',
  tipSendSuccessfully: 'Consejo enviado correctamente',
  walletSettings: 'Configuración de billetera',
  hideZero: 'Ocultar saldos cero',
  hideZeroInfo: 'Tu saldo cero no aparecerá en tu billetera',
  displayFiat: 'Mostrar criptografía en fiat',
  displayFiatInfo: 'Todas las apuestas y transacciones se liquidarán en el equivalente criptográfico.',
  noteForApprox: 'Tenga en cuenta que estas son aproximaciones monetarias.',
  save: 'Ahorrar',
  noWalletFound: 'No se encontró ninguna billetera',
  unableToConvert: 'No se puede convertir',
  limits: 'Límites',
  timePeriodPlaceholder: 'Número de días',
  wagerLimit: 'Límite de apuesta',
  lossLimit: 'Límite de pérdida',
  depositLimit: 'Límite de depósito',
  takeABreak: 'Hacer una pausa',
  customTimePeriod: 'Período de tiempo personalizado',
  timePeriod: 'Período de tiempo',
  selfExclusion: 'Autoexclusión',
  confirm: 'Confirmar',
  setLimit: 'Establecer límite',
  removeLimit: 'Eliminar límite',
  enterAmount: 'Ingrese el monto',
  notSet: 'No establecido',
  hours: 'Horas',
  daily: 'A diario',
  weekly: 'Semanalmente',
  monthly: 'Mensual',
  cancel: 'Cancelar',
  usedLimit: 'Límite usado',
  type: 'Tipo',
  updatedAt: 'Actualizado en',
  editLimit: 'Editar límite',
  providerSearchBarAction: 'Acción',
  providerSearchBarAnotherAction: 'Otra acción',
  providerSearchBarOtherOption: 'Algo más aquí',
  paymentSectionHeading: '¿Necesitas criptomonedas? ',
  limitRemovedMessage: 'Se eliminará su límite de seguimiento.',
  setLimitMessage: 'Está a punto de establecer el siguiente límite en su cuenta. ',
  setBreakMessage: 'Está a punto de bloquear el acceso a su cuenta durante un período de tiempo preestablecido. ',
  setSessionLimitMessage: 'Está a punto de establecer el siguiente límite en su cuenta. ',
  removeSessionLimitMessage: 'Se eliminará el límite de su sesión',
  notAchieved: 'no logrado',
  flexibleRegistration: '¡Registro flexible!',
  mostPlayed: 'Más jugado',
  badge: 'Insignias',
  allBadges: 'Todas las insignias',
  socialMedia: 'redes sociales',
  allLinks: 'Todos los enlaces',
  statistics: 'Estadística',
  newMessage: 'Nuevo mensaje',
  tipFor: 'consejo para',
  play: 'Jugar',
  gameOn: '¡Juego encendido!',
  betOn: 'Apuesta por',
  ecosystemUnbeatableOdds: 'Apueste mejor: acceda a probabilidades inmejorables en eventos emocionantes con nuestra plataforma de apuestas de primer nivel.',
  startBetting: 'Empezar a apostar',
  ecosystemJoinTheFun: 'Únase a la diversión: explore los juegos exclusivos de Moola Hub y más de 9000 favoritos de casino.',
  futures: 'Futuros',
  ecosystemTrade: 'Opere de forma más inteligente, maximice sus ganancias: ¡experimente un apalancamiento de hasta 1000 veces!',
  joinNow: 'Únete ahora',
  clutchCoaster: 'Posavasos Moola Hub',
  searchCurrencies: 'Buscar monedas',
  noNotificationsFound: 'No se encontraron notificaciones',
  notifications: 'Notificaciones',
  lobby: 'Vestíbulo',
  rollercoaster: 'Posavasos Moola Hub',
  applyReferralCode: 'Aplicar código de referencia',
  doNotHaveReferral: '¿No tienes un código? ',
  apply: 'Aplicar',
  referralCode: 'código de referencia',
  copyCode: 'Copiar código',
  referralLink: 'Enlace de referencia',
  copyLink: 'Copiar enlace',
  referralCodeCopied: 'Código de referencia copiado',
  referralLinkCopied: 'Enlace de referencia copiado',
  withdrawAddressCannotBeSame: 'La dirección de retiro no puede ser la misma que la suya',
  userId: 'identificación de usuario',
  active: 'Activo',
  inactive: 'Inactivo',
  currency: 'Divisa',
  hostGames: 'Juegos anfitriones',
  earnCrypto: 'Gana criptomonedas',
  inviteHostAndEarn: 'Invita, organiza y gana: organiza tus propios eventos de póquer',
  startEarning: 'Comience a ganar',
  clutch: 'Centro Moola',
  whitePaper: 'Libro blanco',
  deepDiveInto: 'Sumérjase profundamente en la economía de las monedas de Moola Hub',
  learnMore: 'Más información',
  sport: 'deporte',
  vipRanked: 'clasificado vip',
  betMoreEarnMore: 'Apueste más, gane más: maximice su potencial',
  claimBonus: 'Bonificación de reclamación',
  referredUserId: 'ID de usuario referido',
  bonusId: 'Identificación de bonificación',
  bonusAmount: 'Monto del bono',
  expiresAt: 'Expira el',
  claimedOn: 'Reclamado en',
  preview: 'Avance',
  upload: 'Subir',
  pleaseSelectImage: 'Por favor seleccione imagen',
  imageSizeMustLessThan: 'El tamaño de la imagen debe ser menor que {{size}} megabyte',
  imageSizeFormat: 'Utilice formato de imagen png, jpeg, jpg.',
  maxFileSize: 'Máx. ',
  dragPosition: 'Arrastra para cambiar de posición',
  onlyNumbers: 'Sólo números',
  cannotBeRemoved: 'No se puede eliminar',
  amountInBetween: 'La cantidad debe estar entre diaria y mensual (inclusive)',
  amountEqualOrGreater: 'Cantidad igual o mayor a la semanal',
  amountEqualOrLess: 'La cantidad debe ser igual o menor que la semanal y la mensual.',
  cannotBeIncreased: 'No se puede aumentar',
  enterPassword: 'Introduce la contraseña',
  sessionLimit: 'Límite de sesión',
  timePeriodRequired: 'Se requiere período de tiempo',
  amountGTZero: 'Cantidad mayor que cero',
  mma: 'artes marciales mixtas',
  eaSportsFifa: 'fifa',
  counterStrike: 'Contraataque',
  rugbyUnion: 'Unión de rugby',
  valorant: 'valorante',
  cricket: 'Cricket',
  dota: 'DOTA-2',
  rugbyLeague: 'liga de rugby',
  hilo: 'hilo',
  noRewardsFound: 'No se encontraron recompensas',
  expiredAt: 'Vence en',
  resizeErr: 'Bucle ResizeObserver completado con notificaciones no entregadas.',
  debit: 'débito',
  credit: 'crédito',
  bonusExpired: 'Bono caducado',
  nonCashAmount: 'Monto no en efectivo',
  crash: 'Paseo en Moola',
  cancelBetSuccessfully: 'Apuesta cancelada con éxito',
  start: 'Comenzar',
  invalidBetAmount: 'El importe de la apuesta no es válido',
  zeroError: 'El número de apuesta debe ser mayor que 0',
  loading: 'Cargando',
  flipCoin: 'Lanzamiento de moneda',
  customs: 'Aduanas',
  redeemCode: 'CANJEAR CÓDIGO DE CUPÓN',
  couponText: 'Los publicamos regularmente en nuestro',
  copyrightText: 'Es un hecho establecido desde hace mucho tiempo que un lector se distraerá con el contenido legible de una página cuando mire su diseño.',
  platform: 'Plataforma',
  support: 'Apoyo',
  faq: 'Preguntas frecuentes',
  partnershipProgram: 'Programa de asociación',
  blog: 'Blog',
  helpCenter: 'Centro de ayuda',
  aboutUs: 'Sobre nosotros',
  community: 'Comunidad',
  facebook: 'Facebook',
  twitter: 'Gorjeo',
  instagram: 'Instagram',
  discord: 'Discordia',
  english: 'Inglés',
  spanish: 'Español',
  french: 'Francés',
  legal: 'Legal',
  moreFromClutch: 'MÁS DE Moola Hub',
  cashoutAt: 'Retiro en',
  userProfit: 'Tu beneficio',
  crashHistory: 'Historial de accidentes completos',
  crashPlayNextRoundBtn: 'Jugar (siguiente ronda)',
  crashCancelNextRoundBtn: 'Cancelar (próxima ronda)',
  crashAutoPlayBtn: 'Juego automático (siguiente ronda)',
  crashAutoStartBtn: 'Iniciar reproducción automática',
  crashCancelAutoPlay: 'Cancelar reproducción automática',
  crashGameBetNotFound: 'No se encontraron apuestas en esta ronda actual',
  crashPlayers: 'Jugador',
  numberOfBets: 'Número de apuestas',
  configOnWin: 'Al ganar',
  configOnLoss: 'En pérdida',
  configProfitStop: 'Detener las ganancias',
  configLossStop: 'Detener la pérdida',
  configIncreasedByBtn: 'Aumentar en',
  configAuto: 'Configurar automático',
  instantBet: 'Apuesta instantánea',
  animation: 'Animación',
  maxBet: 'Apuesta máxima',
  crashPointOneTimeMultiplier: 'El punto mínimo de caída está en el multiplicador x1,00.',
  crashPointThousandTimeMultiplier: 'El punto de caída máximo está en el multiplicador x1.000.000,00.',
  crashPointMinOneTimeMultiplier: 'El retiro mínimo es del multiplicador x1.01.',
  fairnessSeedText: 'Semillas',
  fairnessActiveSeeds: 'Semilla de cliente activo',
  fairnessActiveHashedSeeds: 'Semilla de servidor activo (hash)',
  fairnessBetsPair: 'Apuestas totales realizadas con par',
  rotateSeeds: 'Girar par de semillas',
  nextServerSeed: 'Siguiente semilla del servidor (hash)',
  mineGameStarsCountText: 'quedan estrellas',
  mineGameRandomTileText: 'Elige mosaico aleatorio',

  low: "Bajo",
  medium: "Medio",
  high: "Alto",
  rows: "Filas",
  riskLevel: "Nivel de riesgo",
  cancelBetCount: "Cancelar {{count}} Apuestas",
  startCard: "Tarjeta de inicio",
  skipCard: "Saltar tarjeta",
  aceBeingTheLowest: "ACE Siendo el más bajo",
  kingBeingTheHighest: "REY Siendo el más alto",
  higherOrSame: "Mayor o igual",
  lowerOrSame: "Menor o Igual",
  above: "Más alto",
  below: "Más bajo",
  same: "Mismo",
  coefficient: "Coeficiente",
  maxOddReachedPleaseCashout: "Máximo impar alcanzado, por favor retire.",
  gameMode: "Modo de juego",
  chipValue: "Valor de la ficha: 1 ficha = 0,01 {{currencyCode}}",
  undo: "Deshacer",
  clear: "Claro",

  autoBet: "Apuesta automática",
  presets: "Preajustes",
  minHeadTail: "Mínimo cara/cruz",
  pickSide: "Elegir lado",
  coinsCount: "Conteo de monedas",

  blackJackdouble: "Doble",
  hit: "Golpear",
  split: "Dividir",
  stand: "Pararse",
  insurance: "¿Seguro?",
  acceptInsurance: "Aceptar seguro",
  noInsurance: "Sin seguro",

  rounds: "Rondas",
  hits: "Golpes",
  pickNumbers: "Elegir números",
  playTimes: "Jugar {{value}}"
}
